// extracted by mini-css-extract-plugin
export default {"root":"LoadMoreButton_root__-5DSN","icon":"LoadMoreButton_icon__FHrlC"};